import { render, staticRenderFns } from "./UnhandledErrorMessager.vue?vue&type=template&id=3b0ba8e9&"
import script from "./UnhandledErrorMessager.vue?vue&type=script&lang=js&"
export * from "./UnhandledErrorMessager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports